import axios from 'axios';
import { property } from 'lodash';

import getUrl from 'utils/getUrl';
import {
  jsonApiHeaders,
  jsonApiFieldList,
  addQueryParams,
} from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';
import {
  mapPostLogicRuleFromApiModel,
  mapPostSurveyRuleToApiModel,
} from './dataMapper/postLogicDataMapper';
import { SURVEY_TYPE_COLLECTION_PATH } from './config/EntityCollectionPathMap';

const updatePostSurveyLogicRule = (entityId, { ruleId, questionId, rule }) => {
  const url = addQueryParams(
    getUrl.apiV2(
      `${SURVEY_TYPE_COLLECTION_PATH}/${entityId}/item/rules/${ruleId}`,
    ),
    jsonApiFieldList.postSurveyLogic,
  );

  return axios
    .patch(url, mapPostSurveyRuleToApiModel(questionId, rule), {
      headers: jsonApiHeaders,
    })
    .catch(generateApiError())
    .then(property('data'))
    .then(({ data }) => mapPostLogicRuleFromApiModel(data));
};

export default updatePostSurveyLogicRule;
